/* global BLUEKAI_KEY */
/* global BLUEKAI_URL */

function addPageData(data = {}) {
  // This implementation should be updated if we need to support nested data
  return Object.keys(data).forEach((key) => {
    window.bk_addPageCtx(key, data[key]);
  });
}

function addLibraryDownloadScript() {
  const scripts = document.getElementsByTagName('script')[0];
  const s = document.createElement('script');
  s.async = true;
  s.src = BLUEKAI_URL;
  scripts.parentNode.insertBefore(s, scripts);
}

export function track(data = {}) {
  if (window.BKTAG && window.bk_addPageCtx) {
    addPageData(data);
    window.BKTAG.doTag(BLUEKAI_KEY, 4);
  }
}

export default function initializeBluekai({ data = {} }) {
  addLibraryDownloadScript();

  window.bk_async = () => {
    // ALLOW MULTIPLE CALLS/SINGLE PAGE APPS
    window.bk_allow_multiple_calls = true;
    window.bk_use_multiple_iframes = true;

    track(data);
  };
}
